import { SolViewId, SolViewOptions } from '@sol/components';
import { AsmAttachmentViewOptions } from '../components/view/asm-view-read-attachments/asm-attachment-view-options';
import { AsmNotesViewOptions } from '../components/view/asm-view-read-notes/asm-notes-view-options';
import { AsmOwaspTopTenViewOptions } from '../components/view/asm-view-read-owasp-top-ten/asm-owasp-top-ten-view-options';

export class AsmCollaborationViewId {
  public static readonly attachmentCompact = SolViewId.of<SolViewOptions>('asm.attachmentCompact');
  public static readonly attachments = SolViewId.of<AsmAttachmentViewOptions>('asm.attachments', {
    interactive: true,
  });
  public static readonly notes = SolViewId.of<AsmNotesViewOptions>('asm.notes', {
    part: 'summary',
    size: 'default',
    canDeleteAnnotation: false,
    expanded: false,
  });
  public static readonly owaspTopTen = SolViewId.of<AsmOwaspTopTenViewOptions>('asm.owaspTopTen');
  public static readonly owaspVersionEdit = SolViewId.of<SolViewOptions>('asm.owaspVersionEdit');
}
